module.exports = __webpack_public_path__ + "static/media/fg-pay.aebb2b89.png";